import { BaseModule } from "./base.module";
import { DebounceModule } from "./debounce.module";
import { StateMachineModule } from "./state-machine.module";

export class HorizontalScrollNavigationModule extends BaseModule {

	horizontalScrollContainerSelector = '.horizontal-scroll-container';
	horizontalScrollNavigationContainerSelector = '.horizontal-scroll-navigation-container';
	horizontalScrollSelector = '.horizontal-scroll'; // the actual scroll is this
	previousButtonSelector = '.horizontal-scroll-navigation-previous';
	nextButtonSelector = '.horizontal-scroll-navigation-next';
	horizontalScrollItemSelector = '.navigation-item';
	randomOrderDataSelector = 'random';
	containerSelector = '.container';
	boundOnPreviousButtonClick = this.onPreviousButtonClick.bind(this);
	boundOnNextButtonClick = this.onNextButtonClick.bind(this);
	intersectionObserver = null;
	position = { top: 0, left: 0, x: 0, y: 0 };
	stateMachineModule = new StateMachineModule();

	constructor() {
		super();
	}

	initialize() {
		if (typeof document !== 'undefined') {
			// document.addEventListener('constructor.grid-item.component', this.handleGridItemComponent);
			document.addEventListener('DOMContentLoaded', this.onDOMContentLoaded);
		}
	}

	/**
	 * When the DOM content is loaded, then any custom elements (grid-item.component) will also be loaded. Now we load the actions for horizontal scroll navigation
	 */
	onDOMContentLoaded = (event) => {
		if (typeof document !== 'undefined') {
			this.horizontalScrollContainers = document.querySelectorAll(this.horizontalScrollContainerSelector);
			if (this.horizontalScrollContainers && this.horizontalScrollContainers.length > 0) {
				this.handleLoad();
				this.setScrollEventListeners();
				this.setResizeEventListeners();
				this.setMouseEventListeners();
				// handle resize (for nav states)
				// handle navigation button clicks: next & previous item align to left of scroll
			}
			this.horizontalScrollNavigationContainers = document.querySelectorAll(this.horizontalScrollNavigationContainerSelector);
			if (this.horizontalScrollNavigationContainers && this.horizontalScrollNavigationContainers.length > 0) {
				this.handleHorizontalScrollNavigationContainers();
			}
		}
	}

	handleLoad() {
		this.horizontalScrollContainers.forEach((horizontalScrollContainer) => {
			let horizontalScroll = horizontalScrollContainer.querySelector(this.horizontalScrollSelector);

			if (horizontalScroll?.dataset?.order == this.randomOrderDataSelector) {
				this.randomizeHorizontalScrollItems(horizontalScroll);
			}

			if (horizontalScrollContainer) {
				horizontalScrollContainer.dataset.currentItem = 0;
			}
			this.handleHorizontalScrollBoundaries(horizontalScroll);
		});
	}

	/**
	 * 
	 * @param {HTMLElement} horizontalScroll 
	 */
	randomizeHorizontalScrollItems(horizontalScroll) {
		let horizontalScrollItems = horizontalScroll.querySelectorAll(this.horizontalScrollItemSelector);
		// console.log('randomizeHorizontalScrollItems');
		// console.log('horizontalScrollItems', horizontalScrollItems);
		let prevGen = [];
		let orderSet = [];
		let sortedOrderSet = [];
		horizontalScrollItems.forEach((item) => {
			let randomInteger = this.generateRandomInteger(0, horizontalScrollItems.length, prevGen);
			// do not use (css;/flex) order, it will cause issues with navigation (logical vs visual discrepancy)
			// order with javascript instead where back-end sort is not an option
			item.dataset.order = randomInteger;
			orderSet.push({
				order: parseInt(item.dataset.order, 10),
				item: item
			});

			// numeric comparison sort function callback from javascript.info
			function compare(a, b) {
				if (a.order > b.order) return 1; // if the first value is greater than the second
				if (a.order == b.order) return 0; // if values are equal
				if (a.order < b.order) return -1; // if the first value is less than the second
			}

			//filter orderSet by orderset.order, start with lowest
			sortedOrderSet = orderSet.sort(compare);
			prevGen.unshift(randomInteger);
		});

		//based on filtered orderSet, empty existing container and replace with re-ordered items
		horizontalScroll.innerHTML = "";
		sortedOrderSet.forEach((order) => {
			horizontalScroll.appendChild(order.item);
		});
		// horizontalScrollItems.

	}

	/**
	 * 
	 * @param {Number} minimum 
	 * @param {Number} maximum 
	 * @param {Array} previouslyGenerated array, for generating unique in a series
	 */
	generateRandomInteger(minimum, maximum, previouslyGenerated = []) {
		let isAlreadyGenerated = null;
		let randomInteger = Math.floor(Math.random() * (maximum - minimum + 1) + minimum);
		// console.log('previouslyGenerated', previouslyGenerated);
		previouslyGenerated.forEach((alreadyGenerated) => {
			if (randomInteger == alreadyGenerated) {
				isAlreadyGenerated = true;
			}
		});
		if (isAlreadyGenerated === true) {
			// console.log('randomInteger is already generated', randomInteger);
			return this.generateRandomInteger(minimum, maximum, previouslyGenerated);
		}
		return randomInteger;
	}

	handleHorizontalScrollNavigationContainers() {
		this.horizontalScrollNavigationContainers.forEach((horizontalScrollNavigationContainer) => {

			let previousButton = horizontalScrollNavigationContainer.querySelector(this.previousButtonSelector);
			let nextButton = horizontalScrollNavigationContainer.querySelector(this.nextButtonSelector);

			if (previousButton) {
				this.setPreviousButtonEventListeners(previousButton);
			}
			if (nextButton) {
				this.setNextButtonEventListeners(nextButton);
			}
		});
	}

	setPreviousButtonEventListeners(previousButton) {
		previousButton.addEventListener('click', this.boundOnPreviousButtonClick);

	}

	setNextButtonEventListeners(nextButton) {
		nextButton.addEventListener('click', this.boundOnNextButtonClick);
	}

	/**
	 * 
	 * @param {MouseEvent} event 
	 */
	getClosestHorizontalScrollFromButtonClickEvent(event) {
		let horizontalScroll = null;
		let horizontalScrollContainer = event.target.closest(this.horizontalScrollContainerSelector);
		if (horizontalScrollContainer) {
			horizontalScroll = horizontalScrollContainer.querySelector(this.horizontalScrollSelector);
		}
		return horizontalScroll;
	}

	onPreviousButtonClick(event) {
		console.log('onPreviousButtonClick', event);
		let horizontalScroll = this.getClosestHorizontalScrollFromButtonClickEvent(event);
		let horizontalScrollItems = horizontalScroll.querySelectorAll(this.horizontalScrollItemSelector);
		let closestContainer = horizontalScroll.closest(`${this.containerSelector}, ${this.horizontalScrollContainerSelector}`);
		// console.log('horizontalScroll', horizontalScroll);
		// console.log('closestContainer', closestContainer);

		if (horizontalScroll && closestContainer) {
			if (typeof horizontalScrollItems[0] !== 'undefined') {
				var firstItem = horizontalScrollItems[0];
			}
			if (closestContainer.dataset.currentItem) {
				if (typeof horizontalScrollItems[closestContainer.dataset.currentItem] !== 'undefined') {
					if (parseInt(closestContainer.dataset.currentItem) > 0) {
						closestContainer.dataset.currentItem = parseInt(closestContainer.dataset.currentItem) - 1;
						let horizontalScrollItem = horizontalScrollItems[closestContainer.dataset.currentItem];
						if (typeof horizontalScrollItem !== 'undefined') {
							let leftOffsetCalculation = horizontalScrollItem.offsetLeft;
							if (typeof firstItem !== 'undefined') {
								leftOffsetCalculation -= firstItem.offsetLeft;
							}
							horizontalScroll.scroll({
								top: 0,
								left: leftOffsetCalculation,
								// behavior: 'smooth'
							});
						}
					}
					if (parseInt(closestContainer.dataset.currentItem) == 0) {
						closestContainer.dataset.currentItem = parseInt(closestContainer.dataset.currentItem);
						let horizontalScrollItem = horizontalScrollItems[closestContainer.dataset.currentItem];
						if (typeof horizontalScrollItem !== 'undefined') {
							let leftOffsetCalculation = horizontalScrollItem.offsetLeft;
							horizontalScroll.scroll({
								top: 0,
								left: 0,
								// behavior: 'smooth'
							});
						}
					}
				}
			}

		}
	}

	onNextButtonClick(event) {
			console.log('onNextButtonClick', event);
		let horizontalScroll = this.getClosestHorizontalScrollFromButtonClickEvent(event);
		let closestContainer = horizontalScroll.closest(`${this.containerSelector}, ${this.horizontalScrollContainerSelector}`);

		let dryRunHorizontalScroll = {};
		let horizontalScrollItems = horizontalScroll.querySelectorAll(this.horizontalScrollItemSelector);
		if (typeof horizontalScrollItems[parseInt(closestContainer.dataset.currentItem)] !== 'undefined') {
			dryRunHorizontalScroll.scrollLeft = horizontalScrollItems[parseInt(closestContainer.dataset.currentItem)].offsetLeft + 1;
		}

		dryRunHorizontalScroll.scrollWidth = horizontalScroll.scrollWidth;
		dryRunHorizontalScroll.clientWidth = horizontalScroll.clientWidth;
		let dryRunResult = this.handleHorizontalScrollBoundaries(dryRunHorizontalScroll, true);
		// console.log('dryRunHorizontalScroll', dryRunHorizontalScroll);
		// console.log('dryRunResult', dryRunResult);

		// if (dryRunResult.endStateReached === false) {
			console.log('');
			if (horizontalScroll && closestContainer) {
				// console.log('horizontalScroll', horizontalScroll);
				// console.log('closestContainer', closestContainer);
				if (typeof horizontalScrollItems[0] !== 'undefined') {
					var firstItem = horizontalScrollItems[0];
				}
				let maxScrollLeft = (horizontalScroll.scrollWidth - horizontalScroll.clientWidth);
	
				if (closestContainer.dataset && closestContainer.dataset.currentItem) {
					// console.log('current item from dataset is', closestContainer.dataset.currentItem);
					// console.log('length...', horizontalScrollItems.length);
					if (parseInt(closestContainer.dataset.currentItem) <= horizontalScrollItems.length) {
						if (typeof horizontalScrollItems[closestContainer.dataset.currentItem] !== 'undefined') {
							closestContainer.dataset.currentItem = parseInt(closestContainer.dataset.currentItem) + 1;
							let horizontalScrollItem = horizontalScrollItems[closestContainer.dataset.currentItem];
							if (typeof horizontalScrollItem !== 'undefined') {
								if (horizontalScrollItem.offsetLeft >= horizontalScroll.scrollLeft) {
									// event.target.removeAttribute('disabled');
									// console.log('horizontalScrollItem', closestContainer.dataset.currentItem, 'offsetLeft', horizontalScrollItem.offsetLeft, ' is greater than horizontalScroll scrollLeft', horizontalScroll.scrollLeft);
									console.log(horizontalScrollItem.offsetLeft);
									let leftOffsetCalculation = horizontalScrollItem.offsetLeft;
									if (typeof firstItem !== 'undefined') {
										leftOffsetCalculation -= firstItem.offsetLeft;
										horizontalScroll.scroll({
											top: 0,
											left: leftOffsetCalculation,
											// behavior: 'smooth'
										});
									}
								}
							}
						}
					}
				}
			}
		// }
	}

	onHorizontalScrollMouseUp(horizontalScroll, mouseEvent) {
		// mouseEvent.preventDefault();
		// console.log('onHorizontalScrollMouseUp', this, horizontalScroll, mouseEvent);
		// // TODO: also handle updating of current item here, so arrow nav will work nicely also
		// let horizontalScrollItems = horizontalScroll.querySelectorAll(this.horizontalScrollItemSelector);
		// let closestContainer = horizontalScroll.closest(`${this.containerSelector}, ${this.horizontalScrollContainerSelector}`);
		// if (horizontalScrollItems) {
		// 	console.log('scrollLeft', horizontalScroll.scrollLeft);
		// 	for (let index = 0; index < horizontalScrollItems.length; index++) {
		// 		const horizontalScrollItem = horizontalScrollItems[index];
		// 		console.log('h', index, 'offsetLeft', horizontalScrollItem.offsetLeft, ', offsetWidth', horizontalScrollItem.offsetWidth, ', combined offset thingy', ((horizontalScrollItem.offsetLeft + horizontalScrollItem.offsetWidth)));
		// 		if (
		// 			horizontalScroll.scrollLeft >= (horizontalScrollItem.offsetLeft) &&
		// 			horizontalScroll.scrollLeft < (horizontalScrollItem.offsetLeft + horizontalScrollItem.offsetWidth)
		// 		) {
		// 			// update based on scroll
		// 			closestContainer.dataset.currentItem = index;
		// 			// console.log('between');
		// 		}

		// 	}
		// }
	}

	setScrollEventListeners() {
		// console.log('setScrollEventListeners');
		let debounceModule = new DebounceModule();
		this.horizontalScrollContainers.forEach((horizontalScrollContainer) => {
			let horizontalScroll = horizontalScrollContainer.querySelector(this.horizontalScrollSelector);
			if (horizontalScroll) {

				horizontalScroll.addEventListener(
					'scroll',
					debounceModule.debounce((event) => {
						this.onHorizontalScrollEvent(event);
					}, 10)
				);

				if (window.IntersectionObserver) {
					let callBack = (entries, observer) => {
						entries.forEach((entry) => {
							// console.log('entry', entry);
							if (entry.target) {
								/**
								 * @var {IntersectionObserverEntry} entry
								 */
								let target = entry.target;
								let isIntersecting = entry.isIntersecting;
								if (isIntersecting === true) {
									target.classList.add('is-intersecting');
									target.classList.remove('is-not-intersecting');
									// this.getWidth(horizontalScrollContainer, 'full')
									if (
										entry.intersectionRatio < 1.0
									) {
									}
									target.style.opacity = entry.intersectionRatio.toFixed(2);
								}
								if (isIntersecting === false) {
									target.classList.add('is-not-intersecting');
									target.classList.remove('is-intersecting');
								}
							}
						});
					};
					let intersectionObserverThresholds = [];
					for (let index = 0.00; index < 1; index = index + 0.10) {
						intersectionObserverThresholds.push(index);

					}
					let intersectionObserverConfiguration = {
						root: horizontalScroll,
						threshold: intersectionObserverThresholds
					};
					this.intersectionObserver = new IntersectionObserver(callBack, intersectionObserverConfiguration);
					let horizontalScrollItems = document.querySelectorAll(this.horizontalScrollItemSelector);
					horizontalScrollItems.forEach((horizontalScrollItem) => {
						this.intersectionObserver.observe(horizontalScrollItem);
					});
				}

			}
		});
	}

	setResizeEventListeners() {
		let debounceModule = new DebounceModule();
		window.addEventListener(
			'resize',
			debounceModule.debounce((event) => {
				this.horizontalScrollContainers.forEach((horizontalScrollContainer) => {
					let horizontalScroll = horizontalScrollContainer.querySelector(this.horizontalScrollSelector);
					if (horizontalScroll) {
						this.triggerEventOnElement('scroll', horizontalScroll);
					}
				});
			}, 10));
	}

	/**
	 * @see https://htmldom.dev/drag-to-scroll/
	 */
	setMouseEventListeners() {
		this.horizontalScrollContainers.forEach((horizontalScrollContainer) => {
			let horizontalScroll = horizontalScrollContainer.querySelector(this.horizontalScrollSelector);
			if (horizontalScroll) {
				horizontalScroll.style.cursor = 'default';
				let images = horizontalScroll.querySelectorAll('a, img');
				if (images) {
					images.forEach(function (image) {
						image.setAttribute('draggable', false);
					})
				}

				// Attach the handler
				this.boundOnHorizontalScrollMouseDown = this.mouseDownHandler.bind(this, this, horizontalScroll, this.position);
				horizontalScroll.addEventListener('mousedown', this.boundOnHorizontalScrollMouseDown);

			}
		});
	}

	// mouseDownHandler = (...args) => {
	mouseDownHandler = (thisArg, horizontalScroll, pos, mouseDownEvent) => {
		console.log('mouseDownHandler', thisArg, horizontalScroll, pos, mouseDownEvent);
		// console.log('...this', this, mouseDownEvent.clientX, mouseDownEvent.clientY); 
		mouseDownEvent.preventDefault(); // Firefox disable drag (see https://www.redips.net/firefox/disable-image-dragging/)
		horizontalScroll.style.cursor = 'grabbing';
		horizontalScroll.style.userSelect = 'none';
		// horizontalScroll.style.scrollBehavior = 'auto';
		this.position = {
			left: horizontalScroll.scrollLeft,
			top: horizontalScroll.scrollTop,
			// Get the current mouse position
			x: mouseDownEvent.clientX,
			y: mouseDownEvent.clientY,
		};

		this.boundMouseMoveHandler = this.mouseMoveHandler.bind(this, this, horizontalScroll, this.position);
		this.boundMouseUpHandler = this.mouseUpHandler.bind(this, this, horizontalScroll);
		document.addEventListener('mousemove', this.boundMouseMoveHandler);
		document.addEventListener('mouseup', this.boundMouseUpHandler);
	};

	mouseMoveHandler = (thisArg, horizontalScroll, pos, mouseMoveEvent) => {
		// console.log('mouseMoveHandler', this, thisArg, horizontalScroll, pos, mouseMoveEvent);
		// How far the mouse has been moved
		const dx = mouseMoveEvent.clientX - pos.x;
		const dy = mouseMoveEvent.clientY - pos.y;
		let event = {
			target: horizontalScroll
		}
		let deltaX = 0;
		if (dx < 0) {
			deltaX = -1;
			this.onNextButtonClick(event);
		}
		if (dx >= 0) {
			deltaX = +1;
			this.onPreviousButtonClick(event);
		}
		console.log('mouseMoveHandler', pos, dx, deltaX);
		// console.log('deltas', dx, dy);

		// Scroll the element primarily horizontally
		// horizontalScroll.scrollTop = pos.top;
		// horizontalScroll.scrollLeft = pos.left - dx;
		horizontalScroll.style.pointerEvents = 'none';
		// horizontalScroll.style.cursor = 'grabbing';
		// immediate stop
		document.removeEventListener('mousemove', this.boundMouseMoveHandler);
	};

	mouseUpHandler = (e, horizontalScroll) => {
		horizontalScroll.style.cursor = 'default';
		horizontalScroll.style.removeProperty('user-select');
		// horizontalScroll.style.scrollBehavior = 'smooth';
		horizontalScroll.style.pointerEvents = 'all';
		document.addEventListener('mousemove', this.boundMouseMoveHandler);
		
		// mouseEvent.preventDefault();
		// console.log('onHorizontalScrollMouseUp', this, horizontalScroll, mouseEvent);
		// TODO: also handle updating of current item here, so arrow nav will work nicely also
		let horizontalScrollItems = horizontalScroll.querySelectorAll(this.horizontalScrollItemSelector);

		let closestContainer = horizontalScroll.closest(`${this.containerSelector}, ${this.horizontalScrollContainerSelector}`);
		if (horizontalScrollItems) {
			// console.log('scrollLeft', horizontalScroll.scrollLeft);
			for (let index = 0; index < horizontalScrollItems.length; index++) {
				const horizontalScrollItem = horizontalScrollItems[index];
				// console.log('h', index, 'offsetLeft', horizontalScrollItem.offsetLeft, ', offsetWidth', horizontalScrollItem.offsetWidth, ', combined offset thingy', ((horizontalScrollItem.offsetLeft + horizontalScrollItem.offsetWidth)));
				if (
					horizontalScroll.scrollLeft >= (horizontalScrollItem.offsetLeft) &&
					horizontalScroll.scrollLeft < (horizontalScrollItem.offsetLeft + horizontalScrollItem.offsetWidth)
				) {
					// update based on scroll
					closestContainer.dataset.currentItem = index;
					// console.log('between');
				}

			}
		}

		document.removeEventListener('mousemove', this.boundMouseMoveHandler);
		document.removeEventListener('mouseup', this.boundMouseUpHandler);
	};

	/**
	 * https://stackoverflow.com/a/59231107
	 * TODO: refactor to module
	 * 
	 * @param {*} el 
	 * @param {*} type 
	 */
	getWidth(el, type) {
		if (type === 'inner')  // .innerWidth()
			return el.clientWidth;
		else if (type === 'outer')  // .outerWidth()
			return el.offsetWidth;
		let s = window.getComputedStyle(el, null);
		if (type === 'width')  // .width()
			return el.clientWidth - parseInt(s.getPropertyValue('padding-left')) - parseInt(s.getPropertyValue('padding-right'));
		else if (type === 'full')  // .outerWidth(includeMargins = true)
			return el.offsetWidth + parseInt(s.getPropertyValue('margin-left')) + parseInt(s.getPropertyValue('margin-right'));
		else if (type === 'margin-left')  // .outerWidth(includeMargins = true)
			return parseInt(s.getPropertyValue('margin-left'));
		else if (type === 'margin-right')
			return parseInt(s.getPropertyValue('margin-right'));
		else if (type === 'padding-left')
			return parseInt(s.getPropertyValue('padding-right'));
		else if (type === 'padding-right')
			return parseInt(s.getPropertyValue('padding-right'));
		return null;
	}

	onHorizontalScrollEvent(event) {

		let horizontalScrollContainer = event.target.closest(this.horizontalScrollContainerSelector);


		if (horizontalScrollContainer) {
			let horizontalScroll = horizontalScrollContainer.querySelector(this.horizontalScrollSelector);
			if (horizontalScroll) {
				this.handleHorizontalScrollBoundaries(horizontalScroll);
			} else {
				console.warn('no horizontal scroll found from horizontal scroll container down:', horizontalScrollContainer);
			}
		}
	}

	handleHorizontalScrollBoundaries(horizontalScroll, dryRun = false) {
		let startStateReached = false;
		let endStateReached = false;
		// console.log('[HorizontalScrollNavigationModule] handleHorizontalScrollBoundaries', horizontalScroll);
		let maxScrollLeft = (horizontalScroll.scrollWidth - horizontalScroll.clientWidth);
		// let horizontalScrollItems = horizontalScroll.querySelectorAll(this.horizontalScrollItemSelector);
		// console.log('handleHorizontalScrollBoundaries, maxScrollLeft is', maxScrollLeft, 'for scroll', horizontalScroll);
		if (dryRun === false) {
			var closestContainer = horizontalScroll.closest(`${this.containerSelector}, ${this.horizontalScrollContainerSelector}`);
		}
		// scroll left at 0? => start of scroll
		if (horizontalScroll.scrollLeft === 0) {
			startStateReached = true;
			if (dryRun === false) {
				closestContainer.dataset.startStateReached = startStateReached;
			}
		}

		// is scroll left greater than max scroll left?
		if (
			horizontalScroll.scrollLeft >= maxScrollLeft
		) {
			endStateReached = true;
			if (dryRun === false) {
				closestContainer.dataset.endStateReached = endStateReached;
			}
		}
		if (
			// endStateReached === true &&
			horizontalScroll.scrollLeft < maxScrollLeft
		) {
			// for dataset one uses the delete keyword apparently
			endStateReached = false;
			if (dryRun === false) {
				delete closestContainer.dataset.endStateReached;
			}
		}

		if (
			horizontalScroll.scrollLeft > 0
		) {
			startStateReached = false;
			if (dryRun === false) {
				delete closestContainer.dataset.startStateReached;
			}
		}
		return {
			startStateReached: startStateReached,
			endStateReached: endStateReached
		}
	}
}